// extracted by mini-css-extract-plugin
export default {"callToActionBox":"call-to-action-box__callToActionBox__UbdLT"};